import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TOKEN_STORAGE_KEYS } from 'app/core/authentication/constants/token-storage-keys';
import { ISchoolAuthData } from 'app/core/authentication/models/school-auth-data';

@Injectable({
  providedIn: 'root'
})
export class GameUserHeaderCreator {
  public getHTTPHeaders(): HttpHeaders {
    const headers: HttpHeaders = new HttpHeaders();
    return headers.set('Kh-User-Id', this.getUserId());
  }

  public getUserId(): string {
    const authInfo: ISchoolAuthData = JSON.parse(localStorage.getItem(TOKEN_STORAGE_KEYS.SCHOOL_AUTH_DATA) ?? '') as ISchoolAuthData;
    return String(authInfo.UserId);
  }
}
